import { ReportState } from '../constants/report'

export const DATA_EXPORT_POLL_INTERVAL_MS = 3000
export const DATA_EXPORT_PROGRESS_INTERVAL_MS = 350

export function isDataExportInProgress(
  state: ReportState | null | undefined
): boolean {
  return state === ReportState.PENDING || state === ReportState.GENERATING
}

export function isDataExportComplete(
  state: ReportState | null | undefined
): boolean {
  return state === ReportState.COMPLETE
}

export function isDataExportFailed(
  state: ReportState | null | undefined
): boolean {
  return state === ReportState.FAILED
}

export function getNextSimulatedProgress(
  current: number,
  target: number
): number {
  const normalizedCurrent = Math.max(0, Math.min(current, 100))
  const normalizedTarget = Math.max(0, Math.min(target, 100))
  if (normalizedCurrent >= normalizedTarget) {
    return normalizedTarget
  }
  return Math.min(
    normalizedTarget,
    normalizedCurrent + (normalizedTarget - normalizedCurrent) * 0.08
  )
}
